module.exports = __webpack_public_path__ + "8603ebed74704461b986eda6beb03e91.png";